/* eslint-disable */
import { IState } from "@/interfaces/IState";
import { ILesson } from "@/interfaces/lesson/ILesson";
import axios from "axios";

export const lesson = {
    state: {
        lessons: [],
        lesson: {},
        lessonInformation: {},
        planUnits: [],
        planUnitActivities: [],
        weeks: [],
        filterLessonInformation: {},
        updateLessonMode: false,
        lessonToUpdate: {},
        loading: true,
        querySearch: "",
        gridColumnsLesson: true,
        generalAdvance: 45
    },
    mutations: {
        SET_LESSON(state: IState, payload: ILesson) {
            state.lessons = payload;
        },
        SET_ONE_LESSON(state: IState, payload: ILesson) {
            state.lesson = payload;
        },
        ADD_LESSON(state: IState, payload: ILesson) {
            state.lessons.content.unshift(payload);
        },
        SET_INFORMATION_LESSON(state: IState, payload: ILesson) {
            state.lessonInformation = payload;
        },
        SET_FILTER_INFORMATION_LESSON(state: IState, payload: ILesson) {
            state.filterLessonInformation = payload;
        },
        MODE_NEW_LESSON(state: IState, payload: ILesson) {
            state.updateLessonMode = false;
        },
        MODE_UPDATE_LESSON(state: IState, payload: ILesson) {
            state.updateLessonMode = true;
        },
        RESET_LESSON(state: IState) {
            state.lesson = {};
        },
        SET_LOADING(state: IState, payload: boolean) {
            state.loading = payload;
        },
        SET_SEARCH_QUERY(state: IState, payload: boolean) {
            state.querySearch = payload;
        },
        SET_COLUMN_GRID_LESSON(state: IState) {
            state.gridColumnsLesson = !state.gridColumnsLesson;
        },
        SET_PLAN_UNITS(state: any, payload: any) {
            state.planUnits = payload
        },
        SET_PLAN_UNIT_ACTIVITIES(state: any, payload: any) {
            state.planUnitActivities = payload;
        },
        SET_WEEKS(state: any, payload: any) {
            state.weeks = payload;
        }
    },
    actions: {
        // get all Lessons
        async actionGetLessons(context: any, payload: ILesson) {
            console.info('--CONTEXTO--', context)
            const pageNumber =
                typeof payload.pageNumber !== "undefined"
                    ? payload.pageNumber
                    : 0;
            const pageSize =
                typeof payload.pageSize !== "undefined" ? payload.pageSize : 8;
            const query =
                payload.searchQuery !== undefined
                    ? payload.searchQuery
                    : context.state.querySearch;
            if (query !== "undefined") {
                context.commit("SET_SEARCH_QUERY", query);
                console.info("--query Guardado--", context.state.querySearch);
            }

            const stateFilter = payload.stateFilter ? "&isActive=" + payload.stateFilter : '';

            await axios
                .get(
                    `${axios.defaults.baseURL}lesson/?${context.state.querySearch}&pageNumber=${pageNumber}&pageSize=8${stateFilter}`
                )
                .then(res => {
                    console.info("Cargando Todas las clases", res.data);
                    context.commit("SET_LESSON", res.data);
                })
                .catch(error => {
                    console.info("Error al cargar las clases", error);
                });
        },
        async actionGetLesson(context: any, payload: any) {
            await axios
                .get(`${axios.defaults.baseURL}lesson/${payload}`)
                .then(res => {
                    console.info("Cargando leccion", res.data);
                    context.commit("SET_ONE_LESSON", res.data);
                })
                .catch(error => {
                    console.info("Error al cargar la clase", error);
                });
        },

        // get information lessons (selects)
        async actionGetInformationLesson(context: any, payload: any) {
            await axios
                .get(`${axios.defaults.baseURL}information/lesson/${payload}`)
                .then(res => {
                    console.info(
                        "Obteniendo información de la lección",
                        res.data
                    );
                    context.commit("SET_INFORMATION_LESSON", res.data);
                })
                .catch(error => {
                    console.info(
                        "error al obtener información de la lección",
                        error
                    );
                });
        },
        // get information lessons for filter (selects)
        async actionGetFilterInformationLesson(context: any, payload: any) {
            const { institutionId } = await payload.institutionContext;
            await axios
                .get(
                    `${axios.defaults.baseURL}information/filterLesson/${institutionId}`
                )
                .then(res => {
                    console.info(
                        "Obteniendo información de la lección",
                        res.data
                    );
                    context.commit("SET_FILTER_INFORMATION_LESSON", res.data);
                })
                .catch(error => {
                    console.info(
                        "error al obtener información de la lección",
                        error
                    );
                });
        },
        // add new lesson to array
        async addNewLesson(context: any, payload: ILesson) {
            await axios
                .post(`${axios.defaults.baseURL}lesson`, payload)
                .then(res => {
                    console.info("Exito al añadir nueva clase: ", res);
                    context.commit("ADD_LESSON", res.data);
                })
                .catch(error => {
                    console.info("Error al añadir nueva clase:", error);
                });
        },
        // add new lesson to array
        async actionUpdateLesson(context: any, payload: ILesson) {
            await axios
                .put(`${axios.defaults.baseURL}lesson`, payload)
                .then(res => {
                    console.info("Exito al Actualizar la clase: ", res.data);
                })
                .catch(error => {
                    console.info("Error al Actualizar la clase:", error);
                });
        },
		// delete lesson
        async actionDeleteLesson(context: any, payload: ILesson) {
            await axios
                .delete(`${axios.defaults.baseURL}lesson/${payload}`, payload)
                .then(res => {
                    console.info("Exito al eliminar la clase: ", res.data);
                })
                .catch(error => {
                    console.info("Error al eliminar la clase:", error);
                });
        },
		// close lesson
        async actionCloseLesson(context: any, payload: ILesson) {
            await axios
                .post(`${axios.defaults.baseURL}lesson/close/${payload}`, payload)
                .then(res => {
                    console.info("Exito al cerrar la clase: ", res.data);
                })
                .catch(error => {
                    console.info("Error al cerrar la clase:", error);
                });
        },
		// activar lesson
        async actionActivateLesson(context: any, payload: ILesson) {
            await axios
                .post(`${axios.defaults.baseURL}lesson/active/${payload}`, payload)
                .then(res => {
                    console.info("Exito al activar la clase: ", res.data);
                })
                .catch(error => {
                    console.info("Error al activar la clase:", error);
                });
        },
		// inactivar lesson
        async actionInactivateLesson(context: any, payload: ILesson) {
            await axios
                .post(`${axios.defaults.baseURL}lesson/inactive/${payload}`, payload)
                .then(res => {
                    console.info("Exito al inactivar la clase: ", res.data);
                })
                .catch(error => {
                    console.info("Error al inactivar la clase:", error);
                });
        },
        // publicar lesson
        async actionPublishLesson(context: any, payload: any) {
            await axios
                .post(`${axios.defaults.baseURL}lesson/publish/${payload}`, payload)
                .then(res => {
                    console.info("Exito al publicar la clase: ", res.data);
                })
                .catch(error => {
                    console.info("Error al publicar la clase:", error);
                });
        },
        // reset lesson
        setLesson(context: any, payload: ILesson) {
            context.commit("SET_LESSON", payload);
        },
        updateFormLessonMode(context: any, payload: ILesson) {
            context.commit("MODE_UPDATE_LESSON", payload);
        },
        newFormLessonMode(context: any, payload: ILesson) {
            context.commit("MODE_NEW_LESSON", payload);
        },
        resetLessonUpdate(context: any) {
            context.commit("RESET_LESSON");
            context.commit("SET_PLAN_UNITS", []);
            context.commit("SET_PLAN_UNIT_ACTIVITIES", []);
            context.commit("SET_WEEKS", []);
        },
        toggleGridColumnsLesson(context: any) {
            context.commit("SET_COLUMN_GRID_LESSON");
        },

        async actionGetPlanUnits(context: any, payload: any) {
            await axios.get(`${axios.defaults.baseURL}planUnidad/list?idUnidad=${payload.idUnidad}&idAsignatura=${payload.idAsignatura}`)
                .then(response => {
                    context.commit("SET_PLAN_UNITS", response.data);
                })
                .catch(error => {
                    console.log("ERROR PETICION PLAN UNIDADES: " + error);
                })

            // console.log(`${axios.defaults.baseURL}planUnidad/list?idUnidad=${payload}`);
        },

        async actionGetPlanUnitActivities(context: any, payload: any) {
            await axios.get(`${axios.defaults.baseURL}planUnidadActividad/getAll?idPlanUnidad=${payload}`)
                .then(response => {
                    context.commit("SET_PLAN_UNIT_ACTIVITIES", response.data);
                })
                .catch(error => {
                    console.log("ERROR PETICION PLAN UNIDAD ACTIVIDADES: " + error);
                })
        },

        async actionGetWeeks(context: any, payload: any) {
            await axios.get(`${axios.defaults.baseURL}planUnidadSemana/getAll?idPlanUnidad=${payload}`)
                .then(response => {

                    const meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]

                    let semanas = [];

                    response.data.forEach(element => {
                        element.semanas.forEach(week => {
                            week.mes = meses[parseInt(week.iniMes) - 1];

                            semanas.push(week);
                        });
                    });

                    context.commit("SET_WEEKS", semanas);
                })
                .catch(error => {
                    console.log("ERROR PETICION SEMANAS: " + error);
                })
        },
        setOneLesson(context: any, payload: ILesson) {
            context.commit("SET_ONE_LESSON", payload);
        }
    },
    getters: {
        // Get all Lessons
        getLessons(state: IState) {
            return state.lessons;
        },
        getLesson(state: IState) {
            return state.lesson;
        },
        getLessonInformation(state: IState) {
            return state.lessonInformation;
        },
        getLessonFilterInformation(state: IState) {
            return state.filterLessonInformation;
        },
        getUpdateLessonMode(state: IState) {
            return state.updateLessonMode;
        },
        getLoading(state: IState) {
            return state.loading;
        },
        getGridColumnLesson(state: IState) {
            return state.gridColumnsLesson;
        },
        getGeneralAdvance(state: IState) {
            return state.generalAdvance;
        },
        getPlanUnits(state: any) {
            return state.planUnits;
        },
        getPlanUnitActivities(state: any) {
            return state.planUnitActivities;
        },
        getWeeks(state: any) {
            return state.weeks;
        }
    }
};
